import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/credenciamento/';

class SolicitacaoCadastroService {
    constructor() {
        this.idTipo = null;
        this.idConta = null;
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    save(solicitacaoCadastro) {
        console.log('solicitacaoCadastro');
        console.log(solicitacaoCadastro);
        return axios.post(API_URL + 'create', JSON.stringify(solicitacaoCadastro),
        {headers: this.headers});
    }

    salvarPessoa(pessoa){
        return axios.post(API_URL + 'createPessoa', JSON.stringify(pessoa),
        {headers: this.headers});
    }

    findAllByTipoCpfCnpj(idCliente, pertenceMunicipio, cpfCnpj, tipoContribuinte) {
        //this.idTipo = LoginService.currentUserValue.configuracao.idContrTipoEconomico;
        //this.idConta = LoginService.currentUserValue.usuario.idConta;
        return axios.get(API_URL + 'filter?idCliente='+idCliente+'&pertenceMunicipio='+ pertenceMunicipio + '&cpfCnpj='+cpfCnpj+ '&tipoContribuinte='+tipoContribuinte, {headers: this.headers});
    }

    validarPodeCredenciar(idPessoa, cpfCnpj, inscricaoMunicipal, pertenceMunicipio, tipoContribuinte, idCliente) {
        //this.idTipo = LoginService.currentUserValue.configuracao.idContrTipoEconomico;
        //this.idConta = LoginService.currentUserValue.usuario.idConta;
        return axios.get(API_URL + 'validar?idCliente='+idCliente+'&idPessoa='+ idPessoa +'&cpfCnpj='+ cpfCnpj + '&inscricaoMunicipal='+ inscricaoMunicipal + '&pertenceMunicipio='+pertenceMunicipio+ '&tipoContribuinte='+tipoContribuinte, {headers: this.headers});
    }
    validaCamposDisabled(idCliente){
        return axios.get(API_URL + 'validaCamposDisabled?idCliente='+idCliente);
    }

     // Métodos de "localidade.service" replicados para utilizar fora do sistema...
     findAllByFiltro(filtro) {
        return axios.get(API_URL + 'localidade/filter?filtro='+filtro, {headers: this.headers}).then(response => (this.data = response.data.elements));
    }

    findAllBairroByFiltro(idCliente, filtro) {
        return axios.get(API_URL + 'bairro/filter?idCliente='+idCliente+'&filtro='+filtro, {headers: this.headers}).then(response => (this.data = response.data.elements));
    }

    
    findAllLogradouroByFiltro(idCliente, filtro) {
        return axios.get(API_URL + 'logradouro/filter?idCliente='+idCliente+'&filtro='+filtro, {headers: this.headers}).then(response => (this.data = response.data.elements));
    }
    
    findAllByCep(cep) {
        return axios.get(API_URL + 'localidade/filter?cep='+cep, {headers: this.headers}).then(response => (this.data = response.data.elements));
    }
    
    findAllById(id) {
        return axios.get(API_URL + 'localidade/findById?id='+id, {headers: this.headers});
    }

    findAllLograByCep(cep, idCliente) {
        return axios.get(API_URL + 'logradouro/findByCep?cep='+cep+'&idCliente='+idCliente, {headers: this.headers});
    }

    findAllContrFiltro(idCliente, filtro, tipoConsulta, tipoSelecao) {
        return axios.get(API_URL + 'allContr?idCliente='+idCliente+'&filtro='+filtro+'&tipo='+tipoConsulta+'&tipoSelecao='+tipoSelecao, {headers: this.headers});
    }
    
}

export default new SolicitacaoCadastroService();